import React from 'react';
import { Link } from 'react-router-dom';
import image from '../images/s_cover.png';
import style from '../css/Component.module.css';
import { FaPhoneAlt } from 'react-icons/fa';
import useLocation from './useLocation';

function One() {
		const location = useLocation();
		
		
	return (
		<div className={style.container}>
			<div className={style.box}>
				<h1 className={style.header}>
					Plan, repair, deliver exceptional value
				</h1>
				<p className={style.desc}>
					We Bring Your Home Appliances Back to Life in {location}
				</p>
				<p className={style.desc}>
					Your #1 Choice for Washing Machine, Refrigerator, AC, TV, Cooler, Dish
					Washer and Microwave Repairs.
				</p>
				<a href="tel:+917411741171" className={style.desc}>
					<FaPhoneAlt size={15} color="black" /> 7411741171
				</a>
				<div className={style.btn_div}>
					<Link className={style.btn} to={'/service'}>
						Our Services
					</Link>
					<Link className={style.btn} to={'/contact-us'}>
						Book Service
					</Link>
				</div>
			</div>
			<img src={image} alt="" className={style.image} />
		</div>
	);
}

export default One;
